import React from "react";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import "./Help.scss";

// This layout is mounted only inside the protected route boundary in App.
export default function HelpLayout({ children }) {
  const navigate = useNavigate();
  const closeHelp = () => {
    // Help opens in a separate tab. Return to the app if the browser
    // disallows closing a tab that the user opened directly.
    window.close();
    navigate("/inspections/overview", { replace: true });
  };
  return (
    <div className="help-layout">
      <header className="help-site-header">
        <Link className="help-site-header__brand" to="/help" aria-label="PIERS Help home">
          <span><FeatherIcon icon="shield" /></span>
          <strong>PIERS</strong>
          <small>Knowledge<br />Center</small>
        </Link>
        <nav className="help-site-header__actions" aria-label="Help navigation">
          <button className="help-site-header__close" type="button" onClick={closeHelp}>
            <FeatherIcon icon="x" /> Close
          </button>
        </nav>
      </header>
      {children}
    </div>
  );
}
